/* My Smoko Mate — landing interactions
   - scroll reveal (.smk .r -> .on)
   - sticky bottom buy bar toggle
   - FAQ accordion (smkFaq)
   - savings calculator (smkCalc) — price-aware via data-price
   Idempotent + re-inits on Shopify section load (theme editor). */
(function () {
  function initReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.smk .r:not(.on)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('on'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (i) {
        if (i.isIntersecting) { i.target.classList.add('on'); obs.unobserve(i.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
    els.forEach(function (e) { obs.observe(e); });
  }

  function initFloat() {
    var bar = document.querySelector('.smk-float');
    if (!bar || bar.__smkBound) return;
    bar.__smkBound = true;
    var onScroll = function () {
      bar.classList.toggle('on', window.scrollY > window.innerHeight * 0.5);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  window.smkFaq = function (el) {
    var a = el.nextElementSibling;
    var open = a.classList.contains('open');
    var scope = el.closest('.faq-g') || document;
    scope.querySelectorAll('.fq-a').forEach(function (x) {
      x.classList.remove('open');
      if (x.previousElementSibling) x.previousElementSibling.classList.remove('open');
    });
    if (!open) { a.classList.add('open'); el.classList.add('open'); }
  };

  window.smkCalc = function (v, slider) {
    slider = slider || document.querySelector('.smk [data-calc-slider]');
    if (!slider) return;
    var root = slider.closest('.savings') || document;
    var price = parseInt(root.getAttribute('data-price') || '219', 10);
    v = parseInt(v, 10);
    var w = v * 5, m = Math.round(v * 5 * 4.33), y = v * 5 * 48, s = y - price, p = Math.ceil(price / v);
    var q = function (id) { return root.querySelector('[data-calc="' + id + '"]'); };
    if (q('daily')) q('daily').textContent = v;
    if (q('weekly')) q('weekly').textContent = '$' + w;
    if (q('monthly')) q('monthly').textContent = '$' + m;
    if (q('yearly')) q('yearly').textContent = '$' + y.toLocaleString();
    if (q('saving')) q('saving').textContent = '$' + s.toLocaleString();
    if (q('saving-sub')) q('saving-sub').textContent = '($' + y.toLocaleString() + ' \u2212 $' + price + ')';
    if (q('payback-text')) q('payback-text').innerHTML = 'Pays for itself in <b>' + p + ' working days</b>';
    if (q('payback-display')) q('payback-display').textContent = p + ' days';
    var min = parseInt(slider.min, 10), max = parseInt(slider.max, 10);
    var pct = ((v - min) / (max - min)) * 100;
    slider.style.background = 'linear-gradient(to right,#E8580A 0%,#E8580A ' + pct +
      '%,rgba(255,255,255,.1) ' + pct + '%,rgba(255,255,255,.1) 100%)';
  };

  function initCalc(root) {
    var scope = root || document;
    scope.querySelectorAll('.smk [data-calc-slider]').forEach(function (slider) {
      window.smkCalc(slider.value, slider);
    });
  }

  function initAll(root) { initReveal(root); initFloat(); initCalc(root); }

  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* --- FAQ page: accordion + sticky TOC scroll-spy --- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.smk-faqpage .qa .q') : null;
    if (!btn) return;
    var qa = btn.closest('.qa');
    var wrap = qa.querySelector('.a-wrap');
    if (!wrap) return;
    if (qa.classList.contains('open')) {
      wrap.style.maxHeight = null;
      qa.classList.remove('open');
    } else {
      qa.classList.add('open');
      wrap.style.maxHeight = wrap.scrollHeight + 'px';
    }
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.smk-faqpage .qa.open .a-wrap').forEach(function (w) {
      w.style.maxHeight = w.scrollHeight + 'px';
    });
  });
  function spy() {
    if (document.__smkSpyBound) return;
    if (!document.querySelector('.smk-faqpage .sec')) return;
    document.__smkSpyBound = true;
    function onScroll() {
      var secs = [].slice.call(document.querySelectorAll('.smk-faqpage .sec'));
      var links = document.querySelectorAll('.smk-faqpage .toc a');
      if (!secs.length) return;
      var offset = 140; // clears the sticky header
      var current = secs[0];
      secs.forEach(function (s) {
        if (s.getBoundingClientRect().top <= offset) current = s;
      });
      links.forEach(function (l) {
        l.classList.toggle('active', l.getAttribute('href') === '#' + current.id);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState !== 'loading') spy();
  else document.addEventListener('DOMContentLoaded', spy);
  document.addEventListener('shopify:section:load', function () { document.__smkSpyBound = false; spy(); });
})();

/* --- Mobile nav drawer (burger open/close) --- */
(function () {
  function bind() {
    var burger = document.querySelector('.smk .nav-burger');
    var drawer = document.querySelector('.smk .nav-drawer');
    if (!burger || !drawer || burger.__smkDrawer) return;
    burger.__smkDrawer = true;
    function open() {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
    burger.addEventListener('click', function () {
      if (drawer.classList.contains('open')) { close(); } else { open(); }
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();
